<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hi4e1O/tc-custom/9780374712969.jpg?1742449481079" alt="This image is the cover for the book Listening to Stone"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Listening to Stone
      </h1>
      <p class="bookDescription body article font2">
        <p>Throughout the twentieth century, Isamu Noguchi was a vital figure in modern art. From interlocking wooden sculptures to massive steel monuments to the elegant Akari lamps, Noguchi became a master of what he called the "sculpturing of space." But his constant struggle—as both an artist and a man—was to embrace his conflicted identity as the son of a single American woman and a famous yet reclusive Japanese father. "It's only in art," he insisted, "that it was ever possible for me to find any identity at all." <br/>In this remarkable biography of the elusive artist, Hayden Herrera observes this driving force of Noguchi's creativity as intimately tied to his deep appreciation of nature. As a boy in Japan, Noguchi would collect wild azaleas and blue mountain flowers for a little garden in front of his home. As Herrera writes, he also included a rock, "to give a feeling of weight and permanence." It was a sensual appreciation he never abandoned. When looking for stones in remote Japanese quarries for his zen-like Paris garden forty years later, he would spend hours actually listening to the stones, scrambling from one to another until he found one that "spoke to him." Constantly striving to "take the essence of nature and distill it," Noguchi moved from sculpture to furniture, and from playgrounds to sets for his friend the choreographer Martha Graham, and back again working in wood, iron, clay, steel, aluminum, and, of course, stone. <br/>Throughout his career, Noguchi traveled constantly, from New York to Paris to India to Japan, forever uprooting himself to reinvigorate what he called the "keen edge of originality." Wherever he went, his needy disposition and boyish charm drew women to him, yet he tended to push them away when things began to feel too settled. Only through his art—now seen as a powerful aesthetic link between the East and the West—did Noguchi ever seem to feel that he belonged.<br/>Combining the personal correspondence of and interviews with Noguchi and those closest to him—from artists, patrons, assistants, and lovers—Herrera has created an authoritative biography of one of the twentieth century's most important sculptors. She locates Noguchi in his friendships with such artists as Buckminster Fuller and Arshile Gorky, and in his affairs with women including Frida Kahlo and Anna Matta Clark. With the attention to detail and scholarship that made her biography of Gorky a finalist for the Pulitzer Prize, Herrera has written a rich meditation on art in a globalized milieu. <i>Listening to Stone </i>is a moving portrait of an artist compulsively driven to reinvent himself as he searched for his own "essence of sculpture."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hayden Herrera
      </h2>
      
      <p class="authorDescription body article"><P>Hayden Herrera is the author of the Pulitzer Prize–nominated <I>Arshile Gorky: His Life and Work</I>, <I>Frida: A Biography of Frida Kahlo</I>, and <I>Matisse: A Portrait</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?41afa13a